window.FormGroup = function() {
    var self = this;

    var forms = [];
    var notValidCodes = [];

    self.addForm = function(form) {
        forms.push(form);
        return form;
    };

    self.deleteForm = function (form) {
        if(forms.indexOf(form) > -1) {
            forms.splice(forms.indexOf(form), 1);
        }
    };

    self.validateAll = function(validateHidden, withoutErrors) {
        var formsValid = true;

        notValidCodes = [];

        forms.forEach(function(form) {
            var validateFunction = withoutErrors? form.validator.validateWithoutError: form.validator.validate;
            var notValid = !validateFunction(validateHidden);

            if (notValid) {
                formsValid = false;
                notValidCodes.push({"code": BaseForm.VALIDATION_ERROR, "name": form.name});
                if (form.status) {
                    form.status.completed = false;
                }
            }
        });


        return formsValid;
    };

    self.saveAll = function(validateHidden) {
        var promises = [];

        if (self.validateAll(validateHidden)) {
            forms.forEach(function(form) {
                promises.push(form.save());
            });

            return $q.all(promises);
        } else {
            var defer = $q.defer();

            defer.reject(notValidCodes);

            return defer.promise;
        }

    };

    self.runFunc = function (functionName, params) {
        for (var i in forms) {
            try {
                if (forms[i][functionName]) {
                    forms[i][functionName].apply(forms[i], params);
                }
            }
            catch (e) {
                console.error("Running function:", functionName, "Failed in:", forms[i].name, e);
            }
        }
    };

    self.getForms = function () {
        return forms;
    };
}
